import { Game } from '../entities/game';

export { Game }

export class AdminGameGroup {
    public Fullname: string;
    public IsDefault: boolean;
    public Games: Game[];
}


// WEBPACK FOOTER //
// ./src/entities/adminGameGroup.ts